import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'minutesTranslate',
  standalone: false
})
export class MinutesTranslatePipe implements PipeTransform {
  private translate = inject(TranslateService);

  public transform(minutes: number): string {

    if (minutes < 0) {
      throw new Error('Unsupported minutes translation, minutes:  ' + minutes);
    }

    if (minutes === 0) {
      return '-';
    }

    if (minutes === 1) {
      return minutes + this.translate.instant('global.minutes.1');
    }

    if (minutes > 1 && minutes < 5) {
      return minutes + this.translate.instant('global.minutes.2-4');
    }

    return minutes + this.translate.instant('global.minutes.5plus');

  }
}
